import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HomeService } from '../../home.service';

@Component({
    selector: 'app-featured-events',
    templateUrl: './featured-events.component.html',
    styleUrls: ['./featured-events.component.scss'],
})
export class FeaturedEventsComponent implements OnInit {
    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno de dados da API, coleção das recentes notícias
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];

    /**
     * Configuração do slide por breakpoint
     */
    breakpoints = {
        767: {
            perView: 1,
        },
    };

    constructor(private homeService: HomeService, public translate: TranslateService) {}

    ngOnInit(): void {
        this.getEvents();
    }

    getEvents() {
        this.homeService.getFeaturedEvents().subscribe((response) => {
            this.registers = response.registers;
        });
    }
}
